
import { t } from '@/plugins/i18n'
// 黑名单商品code对应值
export const codeName:any = {
  // 次品过多
  10001: {
    // 普通
    normal: t('商品的供应商次品多，无法购买'),
    // 敬体
    strict: t('※商品的供应商次品多，无法购买')
  },
  // 次品过多
  10002: {
    normal: '',
    strict: ''
  },
  // 质量不过关
  10003: {
    normal: '',
    strict: ''
  },
  // 关店
  10004: {
    normal: '',
    strict: ''
  },
  // 2商品侵权
  20001: {
    normal: t('商品侵权，无法购买'),
    strict: t('※商品侵权，无法购买')
  },
  // 3商品次品过多
  20002: {
    normal: t('商品次品过多，无法购买'),
    strict: t('※商品次品过多，无法购买')
  },
  // 4商品缺货
  20003: {
    normal: t('商品缺货，无法购买'),
    strict: t('※商品缺货，无法购买')
  },
  // 5商品易燃易爆品
  20004: {
    normal: t('商品为易燃易爆产品，无法购买'),
    strict: t('※商品为易燃易爆产品，无法购买')
  },
  // 6商品液体
  20005: {
    normal: t('商品为液体，无法购买'),
    strict: t('※商品为液体，无法购买')
  },
  // 7商品仿牌
  20006: {
    normal: t('商品为仿牌，无法购买'),
    strict: t('※商品为仿牌，无法购买')
  },
  // 8商品粉末
  20007: {
    normal: t('商品为粉末，无法购买'),
    strict: t('※商品为粉末，无法购买')
  },
  // 9商品未防腐处理木制品
  20008: {
    normal: t('商品为未防腐处理木制品，无法购买'),
    strict: t('※商品为未防腐处理木制品，无法购买')
  },
  // 10商品管制刀具
  20009: {
    normal: t('商品为管制刀具，无法购买'),
    strict: t('※商品为管制刀具，无法购买')
  },
  // 11商品动植物
  20010: {
    normal: t('商品为动植物，无法购买'),
    strict: t('※商品为动植物，无法购买')
  }
}
